import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AuthShell from '../../components/auth/AuthShell';
import { Loader2, Mail, Check } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, { email: email.trim() });
      setSent(true);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a link to choose a new password." testId="forgot-password-page"
      footer={<><Link to="/login" className="text-[#00D4FF] hover:underline" data-testid="back-to-login">Back to sign in</Link></>}>
      {sent ? (
        <div className="text-center py-6" data-testid="forgot-sent">
          <div className="w-14 h-14 rounded-full bg-[#00D4FF]/15 flex items-center justify-center mx-auto mb-4">
            <Check className="h-6 w-6 text-[#00D4FF]" />
          </div>
          <p className="text-sm text-white font-semibold">Check your inbox</p>
          <p className="text-[11px] text-gray-500 mt-1">If an account exists for <span className="text-[#00D4FF]">{email}</span>, a reset link is on its way. Link expires in 30 minutes.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-[10px] uppercase tracking-widest text-gray-500 font-bold">Email</label>
            <div className="relative mt-1.5">
              <Mail className="absolute left-3 top-3.5 h-4 w-4 text-gray-500" />
              <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
                     data-testid="forgot-email-input"
                     className="w-full pl-10 pr-4 py-3 rounded-lg bg-[#0A0A0A] border border-[#1f1f1f] focus:border-[#00D4FF] text-sm outline-none transition" />
            </div>
          </div>
          <button type="submit" disabled={loading} data-testid="forgot-submit-btn"
                  className="w-full py-3.5 rounded-lg bg-[#FF4D94] text-white font-bold text-sm transition-all hover:brightness-110 hover:scale-[1.01] disabled:opacity-60 flex items-center justify-center gap-2">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Send reset link'}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
